import { useActiveColorScheme } from "@m/alchemy-theme";
export const useIsPanelScheme = () => useActiveColorScheme() === "alchemyPanel";
